import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import { createOrUpdateFilterMutation } from '@app/pcs/data/filter.mutations';
import { validateFilterNameQuery } from '@app/pcs/data/filter.queries';
import {
  deleteFilterMutation,
  shareFilterMutation,
  updateUserFilterMutation,
  updateUserFiltersMutation
} from '@app/pcs/data/user-filter.mutations';
import {
  eligibleUsersForSharingQuery,
  filterSearchQuery,
  searchCriteriaQuery,
  sharedUsersQuery,
  userFilterWithSearchCriteriaDetailedQuery
} from '@app/pcs/data/user-filter.queries';
import {
  Filter,
  UserFilter
} from '@app/pcs/models';

@Injectable()
export class UserFilterDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  fetchFilters() {
    return this.graphqlService.query(userFilterWithSearchCriteriaDetailedQuery);
  }

  search(filterId) {
    return this.graphqlService.query(filterSearchQuery, {filterId});
  }

  fetchFilterSearchCriteria(filterId: number) {
    return this.graphqlService.query(searchCriteriaQuery, {filterId});
  }

  fetchEligibleUsersForSharing(filterId: number) {
    return this.graphqlService.query(eligibleUsersForSharingQuery, {filterId});
  }

  fetchSharedUsers(filterId: number) {
    return this.graphqlService.query(sharedUsersQuery, {filterId});
  }

  saveOrUpdate(filter: Filter) {
    return this.graphqlService.mutation(createOrUpdateFilterMutation, {filter});
  }

  validateFilterName(filterName: string) {
    return this.graphqlService.query(validateFilterNameQuery, {filterName}, hideLoader());
  }

  updateUserFilter(userFilter: UserFilter) {
    return this.graphqlService.mutation(updateUserFilterMutation, {userFilter});
  }

  shareFilter(filterId: number, users: number[]) {
    return this.graphqlService.mutation(shareFilterMutation, {filterId, users});
  }

  deleteFilter(filterId: number) {
    return this.graphqlService.mutation(deleteFilterMutation, {filterId});
  }

  updateUserFilters(userFilters: UserFilter[]) {
    return this.graphqlService.mutation(updateUserFiltersMutation, {userFilters});
  }
}
